import { flattenDeep, uniq } from 'lodash'

export default (permissions = [], expandConfig = {}) =>
  uniq(flattenDeep(permissions.map(i => [i].concat(expandConfig[i] || []))))
